
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import RelatedServices from '../components/RelatedServices';
import FAQKeyword from './FAQKeyword';

function Busserviceforcorporatepune() {



    const cardData =
    {
        keyword: 'Bus Service for Corporate Pune',
        heading: 'Amruta Travels: Bus Service for Corporate Pune',
        headingDescription: 'Looking for a reliable Bus Service for Corporate in Pune? Amruta Travels provides professional corporate transportation solutions for IT companies, manufacturing units, educational institutions, hospitals, and businesses across Pune. Whether you need daily employee transportation, airport transfers, corporate events, conferences, team outings, or annual company trips, our experienced team ensures every journey is safe, punctual, and comfortable. Our fleet includes AC and Non-AC buses, Force Urbania, Tempo Travellers, and luxury buses ranging from 17 to 50 seaters, making it easy to accommodate teams of every size. With transparent pricing, experienced chauffeurs, well-maintained vehicles, and 24×7 booking support, we help businesses manage transportation efficiently while ensuring a premium travel experience for employees, clients, and guests.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

   "services": [
    {
      "name": "Bus Service for Corporate Office Pune",
      "description": "Amruta Travels provides reliable bus services for corporate offices in Pune. We offer dedicated transport solutions for employees, ensuring timely pick-ups and drop-offs. Our buses are comfortable, air-conditioned, and driven by experienced chauffeurs, providing an efficient and hassle-free commuting experience for your workforce."
    },
    {
      "name": "Bus Service for Corporate Office Picnic",
      "description": "Planning a corporate picnic? Amruta Travels offers bus services specifically for corporate outings in Pune. Whether you're heading to a nearby destination or a scenic location, our fleet of buses ensures that your employees travel comfortably and arrive on time, making your picnic a memorable experience."
    },
    {
      "name": "Bus Service for Corporate Outing Pune",
      "description": "For corporate outings in Pune, Amruta Travels offers a range of bus services to meet your needs. Our buses are perfect for transporting groups to team-building events, corporate retreats, or leisure outings, ensuring a comfortable and enjoyable journey for all attendees."
    },
    {
      "name": "Mini Bus for Corporate Outing",
      "description": "Amruta Travels offers mini bus services for corporate outings, ideal for smaller teams or more intimate events. Our mini buses provide the same level of comfort and convenience as our larger buses, with the added benefit of flexibility in terms of destination and group size."
    },
    {
      "name": "AC / Non AC Bus for Corporate Events",
      "description": "Whether it's a business conference, seminar, or corporate event, Amruta Travels provides both AC and non-AC bus options to cater to your specific needs. Our fleet is equipped with modern amenities, and our drivers are professional and punctual to ensure smooth and comfortable transportation."
    },
    {
      "name": "17, 26, 32, 35, 45 Seater Bus for Corporate Outing",
      "description": "Amruta Travels offers a wide selection of buses for corporate outings, including 17, 26, 32, 35, and 45-seater buses. Whether you need a small bus for a compact team or a larger one for a bigger group, we have the perfect vehicle for your outing, with comfortable seating and ample space for relaxation."
    },
    {
      "name": "Employee Transportation Services in Pune",
      "description": "Amruta Travels offers comprehensive employee transportation services in Pune, helping businesses streamline daily commutes. Our buses ensure safe, punctual, and comfortable travel for your employees, with customized routes and schedules to fit your office timings."
    },
    {
      "name": "Bus On Rent For Corporate in Pune",
      "description": "Looking for a bus on rent for your corporate needs in Pune? Amruta Travels provides flexible bus rental options for businesses. Whether it’s for daily employee transportation, corporate events, or outings, our buses are well-maintained and suited to meet your specific requirements."
    },
    {
      "name": "Corporate Bus Services in Hadapsar",
      "description": "Amruta Travels offers corporate Bus services in Hadapsar for businesses looking to provide convenient and comfortable transport for their employees. Our Bus are well-maintained and driven by professional drivers, ensuring a smooth and efficient commuting experience."
    },
    {
      "name": "Corporate Bus Services in Viman Nagar",
      "description": "For businesses located in Viman Nagar, Amruta Travels offers reliable corporate Bus services. We provide door-to-door service for employees, ensuring they arrive at their destinations on time and in comfort. Our fleet of Bus is well-equipped to handle daily commutes efficiently."
    },
    {
      "name": "Corporate Bus Services in Hinjewadi",
      "description": "Amruta Travels provides corporate Bus services in Hinjewadi, ensuring reliable transportation for your employees. Our Bus are equipped with GPS tracking and modern amenities to guarantee safe and comfortable travel during peak hours or off-hours."
    },
    {
      "name": "Corporate Bus Services in Baner Aundh",
      "description": "If your office is located in Baner Aundh, Amruta Travels offers corporate Bus services to meet your needs. Our Bus are punctual, comfortable, and operated by experienced drivers to ensure a hassle-free commuting experience for your employees."
    },
    {
      "name": "Bus Rental for Corporate Events",
      "description": "Amruta Travels offers bus rental services for corporate events in Pune. Our buses are ideal for transporting employees, clients, and guests to conferences, seminars, or special business functions. With a range of bus sizes available, we can accommodate groups of any size with comfort and efficiency."
    }
  ],
  "tableData": [
    ["Bus Service for Corporate Office Pune", "Bus Service for Corporate Office Picnic"],
    ["Bus Service for Corporate Outing Pune", "Mini Bus for Corporate Outing"],
    ["AC / Non AC Bus for Corporate Events", "17, 26, 32, 35, 45 Seater Bus for Corporate Outing"],
    ["Employee Transportation Services in Pune", "Bus On Rent For Corporate in Pune"],
    ["Corporate Bus Services in Hadapsar", "Corporate Bus Services in Viman Nagar"],
    ["Corporate Bus Services in Hinjewadi", "Corporate Bus Services in Baner Aundh"],
    ["Bus Rental for Corporate Events", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Daily Commute Solutions",
    "WhyChoosedescription": "Amruta Travels offers dependable Bus Service for Corporate Pune, ensuring employees reach the office safely and on time with well-maintained and punctual transport solutions."
  },
  {
    "WhyChooseheading": "Ideal for Office Staff and Business Events",
    "WhyChoosedescription": "Our corporate bus services are perfect for daily employee transport, off-site meetings, team outings, seminars, and conferences—tailored to suit your business needs."
  },
  {
    "WhyChooseheading": "Professional Drivers with Route Knowledge",
    "WhyChoosedescription": "We employ trained, uniformed drivers who are experienced and knowledgeable about Pune’s routes, ensuring a safe and efficient commute for your staff."
  },
  {
    "WhyChooseheading": "Cost-Effective and Transparent Pricing",
    "WhyChoosedescription": "We provide affordable corporate transport plans with clear pricing structures—no hidden fees. Get the best value without compromising on service quality."
  },
  {
    "WhyChooseheading": "Well-Maintained, Air-Conditioned Buses",
    "WhyChoosedescription": "All our corporate buses are regularly serviced, clean, and air-conditioned, offering a comfortable and hygienic environment for daily or event-based use."
  },
  {
    "WhyChooseheading": "Flexible Timings and Route Customization",
    "WhyChoosedescription": "We offer flexible pickup and drop-off schedules to match shift timings and office hours. Routes can be fully customized based on employee locations."
  },
  {
    "WhyChooseheading": "Fleet Options for All Group Sizes",
    "WhyChoosedescription": "Whether you need a 20-seater for a small team or a 50-seater for large staff movements, our fleet caters to all corporate group sizes efficiently."
  },
  {
    "WhyChooseheading": "Dedicated Support and Easy Booking",
    "WhyChoosedescription": "Our corporate clients enjoy priority support and a seamless booking experience. Our dedicated team assists with everything from route planning to scheduling and tracking."
  }
]




























    }

const faqData = [
  {
    question: 'How can I book a bus service for corporate events in Pune with Amruta Travels?',
    answer: 'Booking a bus for corporate events in Pune with Amruta Travels is simple. You can reserve a bus via our website, contact our support team, or visit our office. We will assist you in choosing the best bus based on your event and group size.',
  },
  {
    question: 'What types of buses are available for corporate transportation in Pune?',
    answer: 'We offer a range of buses for corporate travel, including 32, 35, 45, and 50 seater options. Our buses are comfortable, air-conditioned, and equipped with ample luggage space to accommodate your business needs.',
  },
  {
    question: 'Can the buses be used for conferences, seminars, and corporate meetings?',
    answer: 'Yes, our buses are ideal for transporting employees and clients to conferences, seminars, or corporate meetings. Whether it is a short trip or an extended journey, we ensure your group travels in comfort and style.',
  },
  {
    question: 'Do you provide buses for corporate outings and team-building events?',
    answer: 'Yes, we offer bus rentals for corporate outings, team-building events, and other corporate functions. Our buses can comfortably transport your employees to destinations within and outside Pune.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for corporate events?',
    answer: 'Absolutely! All our buses are regularly maintained and thoroughly sanitized before each trip, ensuring a safe, clean, and comfortable environment for your employees.',
  },
  {
    question: 'How much does it cost to book a bus for a corporate event in Pune?',
    answer: 'The cost depends on the type of bus, duration of the trip, and any additional services you may require. Please contact us with your event details for a customized and transparent quote.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations for corporate travel?',
    answer: 'Yes, we offer flexible routing and can accommodate multiple pickup and drop-off points for your corporate travel needs. Share your itinerary with us, and we will plan the best route for your group.',
  },
  {
    question: 'Do you provide professional drivers with the buses for corporate events?',
    answer: 'Yes, every bus booking includes a professional, experienced driver. Our drivers are trained to ensure punctuality, safety, and smooth transportation during your corporate events.',
  },
  {
    question: 'Why choose Amruta Travels for corporate bus services in Pune?',
    answer: 'Amruta Travels offers reliable and professional service for corporate clients. We provide well-maintained buses, experienced drivers, and exceptional customer service, ensuring a seamless experience for your business needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rahul Mehta',
    role: 'HR Manager, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for our company’s corporate outing. The bus was spacious, clean, and on time. The driver was professional, and the entire experience was seamless. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rina Desai',
    role: 'Event Coordinator, Pune',
    text: 'Amruta Travels provided a 50-seater bus for our corporate seminar. The bus was equipped with everything we needed, and the driver ensured that we arrived on time. The service was excellent, and our team was very comfortable throughout the journey.',
    rating: 5,
  },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
    {
        src: "/images/gallery/24.jpg",
        alt: "Corporate Bus Service in Pune",
        title: "Corporate Bus Service in Pune | Amruta Travels",
        caption: "Reliable corporate bus transportation for businesses across Pune."
    },
    {
        src: "/images/gallery/28.jpg",
        alt: "Employee Transportation Bus Pune",
        title: "Employee Transportation Services",
        caption: "Daily employee pickup and drop services for IT companies and corporate offices."
    },
    {
        src: "/images/gallery/2.jpg",
        alt: "Corporate Event Bus Rental Pune",
        title: "Corporate Event Transportation",
        caption: "Comfortable buses for seminars, conferences, exhibitions and business events."
    },
    {
        src: "/images/gallery/3.jpg",
        alt: "Corporate Team Outing Bus",
        title: "Corporate Team Outing Bus Rental",
        caption: "Luxury buses for company outings, team-building events and offsite trips."
    },
    {
        src: "/images/gallery/24.jpg",
        alt: "Office Staff Transportation Pune",
        title: "Office Staff Bus Service",
        caption: "Safe and punctual transportation for office staff across Pune."
    },
    {
        src: "/images/gallery/27.jpg",
        alt: "Airport Transfer Bus for Corporate",
        title: "Corporate Airport Transfer",
        caption: "Professional airport pickup and drop services for executives and business guests."
    },
    {
        src: "/images/gallery/29.jpg",
        alt: "Corporate Conference Bus Rental",
        title: "Conference Bus Rental",
        caption: "Reliable transportation for corporate conferences and meetings."
    },
    {
        src: "/images/gallery/30.jpg",
        alt: "Executive Corporate Bus Service Pune",
        title: "Executive Corporate Travel",
        caption: "Premium transportation solutions for senior executives and VIP guests."
    },
    {
        src: "/images/gallery/31.jpg",
        alt: "Corporate Bus Hire Pune",
        title: "Corporate Bus Hire in Pune",
        caption: "Professional corporate bus rental with experienced drivers and flexible fleet options."
    }
];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Service for Corporate Pune",
  "image": "https://bushireinpune.com/assets/images/bus-service-for-corporate-pune.jpg",
  "description": "Rent buses for corporate outings, picnics, and events in Pune with Amruta Travels. Choose from a wide range of options, including mini buses, 17 to 45-seater buses, AC and Non-AC buses, and employee transportation services. Affordable, comfortable, and convenient corporate travel solutions in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4682"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "45", // Adjust based on per km or flat rate for corporate bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-service-for-corporate-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Service for Corporate Pune | Corporate Events, Outings & Employee Transport | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book bus services for corporate events, picnics, and outings in Pune with Amruta Travels. Rent AC and Non-AC buses in 17, 26, 32, 35, and 45-seater options. Affordable employee transport and event services in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/12.jpg"
    alt="Bus Service for Corporate in Pune"
    title="Bus Service for Corporate in Pune | Amruta Travels"
    loading="eager"
    className="img-fluid"
/>
                            <h1
    className="py-1"
    style={{
        color: '#322E77',
        textShadow: '5px 5px 10px rgba(255,255,255,.7)',
        fontWeight: 'bold'
    }}
>
    {cardData.heading}
</h1><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                <div className="mt-5">

<h2 className="darkcolorrr mb-4">
Industries We Serve
</h2>

<p>
Amruta Travels proudly provides reliable corporate bus services across Pune for organizations of every size. From daily employee transportation to large-scale corporate events, we deliver safe, punctual, and professionally managed transport solutions tailored to your business requirements.
</p>

<div className="row mt-4">

<div className="col-md-6">

<h4 className="darkcolorrr">
IT & Software Companies
</h4>

<p>
Daily employee transportation, shift-wise pickup and drop, office shuttle services, airport transfers for clients, and corporate meetings.
</p>

<h4 className="darkcolorrr mt-4">
Manufacturing & Industrial Units
</h4>

<p>
Reliable transportation for factory workers, engineers, management staff, plant visits, and industrial training programs.
</p>

<h4 className="darkcolorrr mt-4">
Educational Institutions
</h4>

<p>
Corporate training programs, university events, seminars, educational tours, conferences, and campus transportation.
</p>

</div>

<div className="col-md-6">

<h4 className="darkcolorrr">
Hospitals & Healthcare
</h4>

<p>
Staff transportation, medical conferences, healthcare workshops, and hospital employee shuttle services.
</p>

<h4 className="darkcolorrr mt-4">
Corporate Events & Conferences
</h4>

<p>
Transportation for annual meetings, exhibitions, seminars, dealer meets, product launches, award ceremonies, and corporate offsites.
</p>

<h4 className="darkcolorrr mt-4">
Startups & Business Parks
</h4>

<p>
Flexible transportation solutions for growing businesses, coworking spaces, and technology parks across Pune.
</p>

</div>

</div>

</div>

<div className="mt-5">

<h2 className="darkcolorrr mb-4">
Why Companies Choose Amruta Travels
</h2>

<p>
Businesses across Pune trust Amruta Travels because we understand that corporate transportation is more than simply providing a bus. Every trip reflects your company's professionalism, which is why we focus on punctuality, passenger safety, clean vehicles, and dependable service. Whether you require a single bus for an executive meeting or multiple vehicles for large corporate events, our experienced team ensures smooth coordination from booking to drop-off.
</p>

<div className="row mt-4">

<div className="col-md-6">

<ul>
<li>Professional & Verified Drivers</li>
<li>GPS Enabled Vehicles</li>
<li>Well-Maintained AC & Non-AC Fleet</li>
<li>24×7 Booking Support</li>
<li>Flexible Corporate Packages</li>

</ul>

</div>

<div className="col-md-6">

<ul>

<li>Transparent Pricing</li>
<li>GST Invoice Available</li>
<li>Daily, Weekly & Monthly Contracts</li>
<li>Employee Safety & Comfort</li>
<li>On-Time Pickup & Drop Guarantee</li>

</ul>

</div>

</div>

</div>

<div className="mt-5">

<h2 className="darkcolorrr mb-4">
Corporate Transportation Solutions We Offer
</h2>

<p>
Every business has unique transportation requirements. At Amruta Travels, we provide customized corporate transportation solutions designed to improve employee convenience, ensure punctuality, and simplify travel management. Whether your requirement is a one-time event or a long-term transportation contract, our experienced team delivers reliable and cost-effective services across Pune and nearby cities.
</p>

<div className="row mt-4">

<div className="col-md-6">

<h4 className="darkcolorrr">
Employee Transportation
</h4>

<p>
Safe and punctual daily employee pickup and drop services for offices, IT parks, manufacturing units and business parks across Pune.
</p>

<h4 className="darkcolorrr mt-4">
Corporate Events
</h4>

<p>
Luxury buses and Tempo Travellers for annual functions, seminars, conferences, product launches, exhibitions and dealer meets.
</p>

<h4 className="darkcolorrr mt-4">
Airport Transfers
</h4>

<p>
Professional airport pickup and drop services for company executives, clients, business delegates and international guests.
</p>

</div>

<div className="col-md-6">

<h4 className="darkcolorrr">
Corporate Team Outings
</h4>

<p>
Comfortable transportation for team-building events, weekend outings, offsite meetings and employee engagement activities.
</p>

<h4 className="darkcolorrr mt-4">
Executive Travel
</h4>

<p>
Premium Force Urbania, Tempo Traveller and luxury buses for directors, senior management and VIP corporate guests.
</p>

<h4 className="darkcolorrr mt-4">
Long-Term Corporate Contracts
</h4>

<p>
Flexible monthly and yearly transportation contracts with dedicated vehicles, professional drivers, GST billing and priority customer support.
</p>

</div>

</div>

</div>

<div className="mt-5">

<h2 className="darkcolorrr mb-4">
Why Businesses Prefer Outsourcing Corporate Transportation
</h2>

<p>
Managing transportation internally can be time-consuming and expensive. By partnering with Amruta Travels, businesses can focus on their core operations while we handle every aspect of employee and corporate travel. Our experienced operations team ensures smooth coordination, professional drivers, well-maintained vehicles, and reliable scheduling for both daily transportation and special corporate events.
</p>

<div className="row mt-4">

<div className="col-md-6">

<ul>
<li>Reduce operational costs</li>
<li>No vehicle maintenance expenses</li>
<li>No driver recruitment or management</li>
<li>Flexible fleet based on business requirements</li>
<li>Dedicated account support</li>
</ul>

</div>

<div className="col-md-6">

<ul>
<li>Professional transport management</li>
<li>Improved employee satisfaction</li>
<li>Reliable backup vehicles</li>
<li>GST billing for businesses</li>
<li>Scalable solutions for growing companies</li>
</ul>

</div>

</div>

</div>
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <RelatedServices page="corporate" />

<TestimonialKeyword
    title="Testimonial"
    description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
    reviews={testimonialsData}
/>

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
    src={image.src}
    alt={image.alt}
    title={image.title}
    loading="lazy"
    className="gallery-image"
/>

<p className="text-center mt-2 small text-muted">
    {image.caption}
</p>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busserviceforcorporatepune;